export const COSMOS_CHAIN_TEST_VECTORS = [
    { chain: "cosmoshub", denom: "uatom" },
    { chain: "osmosis", denom: "uosmo" },
    { chain: "axelar", denom: "uaxl" },
    { chain: "noble", denom: "uusdc" },
    { chain: "agoric", denom: "ubld" },
];
export const COSMOS_ACCOUNT_TEST_VECTORS = [
    {
        chain: "cosmoshub",
        address: "cosmos1qphf0ferqcch0jca9hlqfm3x0eds3dpkac4g9j",
        delegator: "cosmos1qphf0ferqcch0jca9hlqfm3x0eds3dpkac4g9j",
        denom: "uatom",
    },
    {
        chain: "osmosis",
        address: "osmo1qyksxgv03ngylanwzh2mx6k768frgjc0rvjycg",
        delegator: "osmo1qyksxgv03ngylanwzh2mx6k768frgjc0rvjycg",
        denom: "uosmo",
    },
    {
        chain: "axelar",
        address: "axelar1qquc5dtfsapta73uajnncs3360dk50qx9hldsh",
        delegator: "axelar1qquc5dtfsapta73uajnncs3360dk50qx9hldsh",
        denom: "uaxl",
    },
    {
        chain: "noble",
        address: "noble1qe8uuf5x69c526h4nzxwv4ltftr73v7qgk33qz",
        delegator: "noble1qe8uuf5x69c526h4nzxwv4ltftr73v7qgk33qz",
        denom: "uusdc",
    },
    {
        chain: "agoric",
        address: "agoric1qyqtn4529298wn62k9kau6qrs5gdpyajxr4zsx",
        delegator: "agoric1qyqtn4529298wn62k9kau6qrs5gdpyajxr4zsx",
        denom: "ubld",
    },
];
export const COSMOS_REWARDS_TEST_VECTORS = COSMOS_ACCOUNT_TEST_VECTORS.filter((vector) => vector.chain !== "noble");
export const COSMOS_BLOCK_HEIGHT_FIXTURE_VECTORS = [
    { chain: "cosmoshub", fixture: "getBlockHeightCosmoshub" },
];
export const COSMOS_BLOCK_QUERY_FIXTURE_VECTORS = [
    { chain: "cosmoshub", block: 32_000_000, fixture: "getBlockByNumberCosmoshub" },
];
export const COSMOS_TRANSACTION_BY_HASH_FIXTURE_VECTORS = [
    {
        chain: "cosmoshub",
        hash: "58305EE252263E30489F06A87FEEA77B4B5F0E6C86463A765A68199F0A6E3078",
        fixture: "getTransactionByHashCosmoshub",
    },
];
export const COSMOS_TOKEN_BALANCE_FIXTURE_VECTORS = [
    {
        chain: "cosmoshub",
        address: "cosmos1qyqszqgpqyqszqgpqyqszqgpqyqszqgpjnp7du",
        denom: "uatom",
        fixture: "getTokenBalanceCosmoshub",
    },
];
export const COSMOS_TOKEN_METADATA_FIXTURE_VECTORS = [
    { chain: "cosmoshub", denom: "uatom", fixture: "getTokenMetadataCosmoshub" },
    { chain: "osmosis", denom: "uosmo", fixture: "getTokenMetadataOsmosis" },
    { chain: "noble", denom: "uusdc", fixture: "getTokenMetadataNoble" },
    { chain: "agoric", denom: "ubld", fixture: "getTokenMetadataAgoric" },
    { chain: "axelar", denom: "uaxl", fixture: "getTokenMetadataAxelar" },
];
// Pinned heights mirror fixtures/cosmos/_capture-lib.sh — keep in sync.
export const COSMOS_BLOCK_BY_HASH_FIXTURE_VECTORS = [
    { chain: "cosmoshub", block: 32_000_000, hash: "0x72BE61E0ECF5AB70EED5ED6924DEEADE5B58BB572C4E4D64C82AB12E270F2358", fixture: "getBlockByHashCosmoshub" },
    { chain: "osmosis", block: 63_850_000, hash: "0x7EF85B72B2D0AB437881D315C2C07E7520C8D161E8AAEC3B9A48C163E7BC366A", fixture: "getBlockByHashOsmosis" },
    { chain: "agoric", block: 25_860_000, hash: "0x4FADBF09071EB64965873D25EDE2C76238ADF13AF27DB91385BB55A9FB2B4BFC", fixture: "getBlockByHashAgoric" },
    { chain: "noble", block: 52_610_000, hash: "0x691F6144E1818A928DFD19BBA0D89C20B55799ABECFDEAC7970ABC7ADD29C179", fixture: "getBlockByHashNoble" },
    { chain: "axelar", block: 29_890_000, hash: "0xA672528DDEDFB7A487B1F4EC0BC35BAE1017F1E9EE1C0CCFA3C0D1DADE5E01A5", fixture: "getBlockByHashAxelar" },
];
export const COSMOS_BLOCK_RESULTS_FIXTURE_VECTORS = [
    { chain: "cosmoshub", block: 32_000_000, fixture: "getBlockResultsCosmoshub" },
    { chain: "osmosis", block: 63_850_000, fixture: "getBlockResultsOsmosis" },
    { chain: "agoric", block: 25_860_000, fixture: "getBlockResultsAgoric" },
    { chain: "noble", block: 52_610_000, fixture: "getBlockResultsNoble" },
    { chain: "axelar", block: 29_890_000, fixture: "getBlockResultsAxelar" },
];
export const COSMOS_BLOCK_TRANSACTIONS_FIXTURE_VECTORS = [
    { chain: "cosmoshub", block: 32_000_000, fixture: "getBlockTransactionsCosmoshub" },
    { chain: "osmosis", block: 63_850_000, fixture: "getBlockTransactionsOsmosis" },
    { chain: "agoric", block: 25_860_000, fixture: "getBlockTransactionsAgoric" },
    { chain: "noble", block: 52_610_000, fixture: "getBlockTransactionsNoble" },
    { chain: "axelar", block: 29_890_000, fixture: "getBlockTransactionsAxelar" },
];
